import { useEffect, useRef } from 'react';
import PageBack from '../components/PageBack';
import SiteFooter from '../../../shared-web/SiteFooter';
import { mountCheck } from './check/check';
import oneSidedFriendshipHtml from './check/one-sided-friendship.html?raw';

/**
 * The self-check pages (2026-10-26): "Is my friendship one-sided?" and the like.
 * Each is written by hand for one situation people search for, and ends at that
 * situation's light and at a conversation with Ember. They are marketing pages
 * like /compare — one at a time, never generated per light and never listed in
 * a directory (spec §0.3 / §4.17: no SEO layer batch-published over the lights,
 * no browsing surface). The questions and every result card are in the
 * server-rendered HTML; check/check.ts reads the answers in the browser with
 * the shared check module, which also writes the line /talk opens on.
 */
export const CHECK_PAGES: Record<string, string> = {
  '/check/one-sided-friendship': oneSidedFriendshipHtml,
};

export default function CheckPage({ html }: { html: string }) {
  const ref = useRef<HTMLDivElement>(null);
  useEffect(() => (ref.current ? mountCheck(ref.current) : undefined), [html]);
  return (
    <div className="flex min-h-screen flex-col text-ink" style={{ background: 'var(--eh-canvas, #fcf7ec)' }}>
      <div className="eh-page-top authored-top-wrap">
        <PageBack />
      </div>
      <div ref={ref} className="ember-page-html flex-1" dangerouslySetInnerHTML={{ __html: html }} />
      <SiteFooter theme="light" />
    </div>
  );
}
